import type { Middleware, SWRHook } from "swr";
import { usePathname } from "next/navigation";

// 보유종목(/holding)·대시보드(/dashboard) 에서만 주기적 자동 refresh 를 허용하는 SWR 전역 미들웨어.
// 그 외 모든 라우트에선 각 훅의 refreshInterval/포커스·재접속 재검증을 강제로 끈다.
// (초기 mount fetch 와 수동 mutate 는 그대로 → 데이터는 정상 로드, 백그라운드 폴링만 차단)
//
// 호출부(수십 곳)의 refreshInterval 을 일일이 건드리지 않고 한 곳에서 라우트 기반 제어.
const LIVE_ROUTES = ["/holding", "/dashboard"];

export const refreshGate: Middleware = (useSWRNext: SWRHook) => (key, fetcher, config) => {
  const pathname = usePathname();
  const live = LIVE_ROUTES.includes(pathname);
  const marketTicker = key === "/api/market";
  const gated = live || marketTicker
    ? config
    : { ...config, refreshInterval: 0, revalidateOnFocus: false, revalidateOnReconnect: false };
  return useSWRNext(key, fetcher, gated);
};
